var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-sidebar"},[_c('nav-tree-root',{attrs:{"nav":"","dense":"","items":_vm.navItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }